import script from "./bank-statement.vue?vue&type=script&setup=true&lang=js"
export * from "./bank-statement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__